<div class="map-holder" [ngStyle]="{ height: height }">
  <agm-map [latitude]="location.lat" [longitude]="location.long" [zoom]="zoom">
    <agm-map-type-control></agm-map-type-control>
    <agm-marker
      [latitude]="location.lat"
      [longitude]="location.long"
      [markerDraggable]="!disabled"
      (dragEnd)="onMarkerChange($event)"
    ></agm-marker>
  </agm-map>
</div>
